import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { RELATIONSHIP_IMPORTANT_OPTIONS } from '@/pages/Onboarding/options/RelationshipImportant/RELATIONSHIP_IMPORTANT_OPTIONS';
import { getRelationshipImportantTitleById } from '@/pages/Onboarding/options/RelationshipImportant/utils/getRelationshipImportant';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const RelationshipImportantScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'RelationshipImportant',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const relationshipImportant = form.watch('relationship_important');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['relationship_important']>,
  ) => {
    form.setValue('relationship_important', option.id);
  };

  const handleNextStep = () => {
    const relationshipImportantTitle = getRelationshipImportantTitleById(
      relationshipImportant,
    );
    userService.createOrUpdate({
      onboarding_data: {
        relationship_important: relationshipImportantTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What's Important To Him In A Relationship?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="grid-with-icon">
          {RELATIONSHIP_IMPORTANT_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={relationshipImportant === option.id}
              control={form.control}
              option={option}
              name="relationship_important"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="grid-with-icon"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!relationshipImportant}
      />
    </OnboardingPage>
  );
};
